import { Dialog, DialogContent, DialogDescription, DialogTitle } from "./ui/dialog";
import { IntakeForm } from "./IntakeForm";
import { ChevronMark } from "./ChevronMark";

export function LeadModal({ open, source, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        data-testid="lead-intake-modal"
        className="max-w-xl overflow-hidden border-border bg-bone p-0 sm:rounded-3xl"
      >
        <div className="flex items-center gap-3 bg-forest-deep px-6 py-5">
          <ChevronMark light className="h-7 w-auto shrink-0" />
          <div>
            <DialogTitle className="font-display text-lg font-bold text-bone">
              Book Your Free Strategy Call
            </DialogTitle>
            <DialogDescription className="text-xs text-emerald-100/60">
              4 quick steps · under a minute · no obligation
            </DialogDescription>
          </div>
        </div>
        <div className="max-h-[75vh] overflow-y-auto p-6">
          <IntakeForm key={String(open)} source={source} idPrefix="modal-intake" />
        </div>
      </DialogContent>
    </Dialog>
  );
}
